import { render } from "./LookingFor.vue?vue&type=template&id=202c4a8e&scoped=true"
import script from "./LookingFor.vue?vue&type=script&lang=js"
export * from "./LookingFor.vue?vue&type=script&lang=js"

import "./LookingFor.vue?vue&type=style&index=0&id=202c4a8e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-202c4a8e"]])

export default __exports__